import hi from './hi.js'
import gu from './gu.js'
import de from './de.js'
export default {
    hi,
    de,
    gu,
    en: {
        'Edit': 'Edit',
        'Delete': 'Delete',
        'Save': 'Save',
        'Reset': 'Reset',
        'Update': 'Update',
        'Create': 'Create',
        'Cancel': 'Cancel',
        'Menu': 'Menu',
        'Manage Menu': 'Manage Menu',
        'ID': 'ID',
        'Icon': 'Icon',
        'Remark': 'Remark',
        'URL': 'URL',
        'Operations': 'Operations',
        'Manage Roles': 'Manage Roles',
        'Date': 'Date',
        'Permission': 'Permission',
        'Add Role': 'Add Role',
        'Edit Role': 'Edit Role',
        'Check all': 'Check all',
        'Confirm': 'Confirm',
        'First Name': 'First Name',
        'Last Name': 'Last Name',
        'Email': 'Email',
        'Edit User': 'Edit User',
        'Gender': 'Gender',
        'Male': 'Male',
        'Female': 'Female',
        'Email Address': 'Email Address',
        'Manage Users': 'Manage Users',
        'Manage Permissions': 'Manage Permissions',
        'Edit Permission': 'Edit Permission',
        'Display Name': 'Display Name',
        'General Settings': 'General Settings',
        'Admin Email': 'Admin Email',
        'Timezone': 'Timezone',
        'Date Format': 'Date Format',
        'Time Format': 'Time Format',
        'Logo Upload': 'Logo Upload',
        'Create Menu': 'Create Menu',
        'Edit Menu': 'Edit Menu',
        'Menu Title': 'Menu Title',
        'Menu Icon': 'Menu Icon',
        'Select Parent': 'Select Parent',
        'Category': 'Category',
        'Menu status': 'Menu status',
        'Order Number': 'Order Number',
        'Enable': 'Enable',
        'Disable': 'Disable',
        'Modified at': 'Modified at',
        'Parent name': 'Parent name',
        'Search': 'Search',
        'Use 24h clock': 'Use 24h clock',
        'Use 12h clock': 'Use 12h clock',
        'Select Timezone': 'Select Timezone',
        'Select DateFormat': 'Select DateFormat',
        'Select TimeFormat': 'Select TimeFormat',
        'Select language': 'Select language',
        'Select currency': 'Select currency',
        'Please input valid email address': 'Please input valid email address',
        'Language': 'Language',
        'Currency': 'Currency',
        'Manage spenders': 'Manage spenders',
        'Company name': 'Company name',
        'Address': 'Address',
        'Manage organizations': 'Manage organizations',
        'Website': 'Website',
        'Phone': 'Phone',
        'Place': 'Place',
        'Name': 'Name',
        'Create Organization': 'Create Organization',
        'Confirm password': 'Confirm password',
        'password': 'Password',
        'Zipcode': 'Zipcode',
        'Create Spender': 'Create Spender',
        'Password and password confirmation both should be match': 'Password and password confirmation both should be match',
        'Please enter valid zipcode': 'Please enter valid zipcode',
        'Please enter proper website URL': 'Please enter proper website URL',
        'Edit Role Permission': 'Edit Role Permission',
        'Role': 'Role',
        'Permissions': 'Permissions',
        'Delete Role': 'Delete Role',
        'Parent Role': 'Parent Role',
        'Created at': 'Created at',
        'Role name is required': 'Role name is required',
        'Create Role': 'Create Role',
        'Role name': 'Role name',
        'Activity Logs': 'Activity Logs',
        'Manage clubs': 'Manage clubs',
        'Create Club': 'Create Club',
        'Select Organization': 'Select Organization',
        'Please select': 'Please select',
        'Organization': 'Organization',
        'Organization_new': 'Organization',
        'Start typing': 'Start typing',
        'Changed By': 'Changed By',
        'Changed Data': 'Changed Data',
        'On Module': 'On Module',
        'Action': 'Action',
        'Alphabetical filter': 'Alphabetical filter',
        'Success': 'Success',
        'Error': 'Error',
        'Warning': 'Warning',
        'OK': 'OK',
        'Spender': 'Spender',
        'This will permanently delete the': 'This will permanently delete the',
        'Do you want to continue?': 'Do you want to continue?',
        'Image type must be of JPG or PNG format': 'Image type must be of JPG or PNG format',
        'Image size should not exceed to 2MB': 'Image size should not exceed to 2MB',
        'File size should not exceed to 2MB' : 'File size should not exceed to 2MB',
        'or upload an invoice with a payment slip.': 'or upload an invoice with a payment slip.',
        'upload an invoice with a payment slip.' : 'upload an invoice with a payment slip',
        'Payment instructions:' : 'Payment instructions:',
        'Please enter the recipient\'s IBAN and account details': 'Please enter the recipient\'s IBAN and account details',
        'Club': 'Club',
        'Select menu icon': 'Select menu icon',
        'Select parent menu': 'Select parent menu',
        'Select category': 'Select category',
        'Clubs': 'Clubs',
        'Contacts': 'Contacts',
        'My Profile': 'My Profile',
        'Profile Image': 'Profile Image',
        'Change Password': 'Change Password',
        'Current Password': 'Current Password',
        'New Password': 'New Password',
        'Create club contact': 'Create club contact',
        'Can vote?': 'Can vote?',
        'Manage club contacts': 'Manage club contacts',
        'Manage organization contacts': 'Manage organization contacts',
        'Active': 'Active',
        'Inactive': 'Inactive',
        'Yes': 'Yes',
        'No': 'No',
        'Create organization contact': 'Create organization contact',
        'Club details': 'Club details',
        'Details': 'Details',
        'Update Spender': 'Update Spender',
        'Update Club': 'Update Club',
        'Update Organization': 'Update Organization',
        'Update organization contact': 'Update organization contact',
        'Manage Fachstellen': 'Manage Social Units',
        'Update Fachstellen': 'Update Social Unit',
        'Create Fachstellen': 'Create Social Unit',
        'This field is required': 'This field is required',
        'Update club contact': 'Update club contact',
        'DOB': 'Date of birth',
        'Admission': 'Admission',
        'Manage patenkinder': 'Manage Godchild',
        'Create patenkind': 'Create Godchild',
        'Origin country': 'Origin country',
        'Select country': 'Select country',
        'Father name': 'Father name',
        'Mother name': 'Mother name',
        'Other': 'Other',
        'Primary mobile number': 'Primary mobile number',
        'Secondary mobile number': 'Secondary mobile number',
        'Update patenkind': 'Update Godchild',
        'Manage Fachstellen Contacts': 'Manage Social Unit Contacts',
        'Create Fachstellen Contacts': 'Create Social Unit Contacts',
        'Update Fachstellen Contacts': 'Update Social Unit Contacts',
        'Fachstellen Name': 'Social Unit Name',
        'Patenkinder Name': 'GodChild Name',
        'Case': 'Case',
        'Manage Cases': 'Manage Cases',
        'Can Login?': 'Can Login?',
        'Case Title': 'Case Title',
        'Create Case': 'Create Case',
        'Please enter number': 'Please enter number',
        'Patenkinder': 'GodChild',
        'Age': 'Age',
        'Patenkinder Details': 'GodChild Details',
        'Leaving': 'Leaving',
        'Years': 'Years',
        'Year': 'Year',
        'Month': 'Month',
        'Login': 'Login',
        'Fachstellen sign up': 'Social Unit sign up',
        'Signup': 'Signup',
        'Cases': 'Cases',
        'Function': 'Function',
        'Case Details': 'Case Details',
        'Created on': 'Created on',
        'Title': 'Title',
        'Attachment': 'Attachment',
        'Reject case': 'Reject case',
        'Expected amount': 'Expected amount',
        'Status': 'Status',
        'Vote Details': 'Vote Details',
        'Total voters': 'Total voters',
        'Total voters1': 'Total voters',
        'Agree': 'Agree',
        'Not agree': 'Not agree',
        'In discussion': 'In discussion',
        'Club member details': 'Club member details',
        'Review Details': 'Review Details',
        'Amount': 'Amount',
        'Confirmed amount': 'Confirmed amount',
        'Approve and send email': 'Approve and send email',
        'Approve': 'Approve',
        'Update case': 'Update case',
        'Fachstellen': 'Social Unit',
        'Approved cases': 'Approved cases',
        'Rejected cases': 'Rejected cases',
        'Invite': 'Invite',
        'Invite fachstellen': 'Invite Social Unit',
        'Send link': 'Send link',
        'General needs of the child': 'General needs of the child',
        'Criteria for supporting the godchild': 'Criteria for supporting the godchild',
        'It can be ensured that the support lines benefit only the child.': 'It can be ensured that the support lines benefit only the child.',
        'The payment is made via a specialist office or with a direct payment slip (eg bill music school).': 'The payment is made via a specialist office or with a direct payment slip (eg bill music school).',
        'It is ensured that no other organization (public sector, insurance, etc.) would have to pay for the neediness?': 'It is ensured that no other organization (public sector, insurance, etc.) would have to pay for the neediness?',
        'The support service promotes the integration of the child into its environment / society (eg supporting activities with other children).': 'The support service promotes the integration of the child into its environment / society (eg supporting activities with other children).',
        'Concrete support': 'Concrete support',
        'What': 'What',
        'Cost': 'Cost',
        'Invalid number format': 'Invalid number format',
        'Categories': 'Categories',
        'Description': 'Description',
        'Description1': 'Description',
        'Reject and send email': 'Reject and send email',
        'Reject': 'Reject',
        'Vote now': 'Release Case',
        'Skip Voting': 'Skip Voting',
        'Go ahead': 'Go to Confirm',
        'Life situation': 'Life situation',
        'Needy': 'Needy',
        'Special': 'Special',
        'Legal representatives': 'Legal representatives',
        'Parent': 'Parent',
        'Guardian': 'Guardian',
        'Publication': 'Publication',
        'YES, this data may be published anonymously on the KiPaKi homepage': 'YES, this data may be published anonymously on the KiPaKi homepage',
        'NO, no data may be published on the KiPaKi homepage': 'NO, no data may be published on the KiPaKi homepage',
        'Only the following data may be published': 'Only the following data may be published',
        'Admission criteria': 'Admission criteria',
        'The godchild is younger than 17 years or has no income (from profession or teaching)': 'The godchild is younger than 17 years or has no income (from profession or teaching)',
        'Legal representatives relation': 'Legal representatives relation',
        'Application and supervision of sponsorship / support services are provided by the department?': 'Application and supervision of sponsorship / support services are provided by the department?',
        'It is pursued with the godchild a longer-term goal. (Recurring Benefits)': 'It is pursued with the godchild a longer-term goal. (Recurring Benefits)',
        'Hereby, the department confirms, in agreement with the legal representative, the correctness and release of this data in connection with the sponsorship.': 'Hereby, the department confirms, in agreement with the legal representative, the correctness and release of this data in connection with the sponsorship.',
        'Confirmation': 'Confirmation',
        'It can be ensured that the respective support lines exclusively benefit the child.': 'It can be ensured that the respective support lines exclusively benefit the child.',
        'There are / were no conflicts with public authorities or authorities.': 'There are / were no conflicts with public authorities or authorities.',
        'Patenkind': 'Godchild',
        'Go to next stage': 'Go to next stage',
        'Reply': 'Reply',
        'Voting note': 'Additional Note',
        'Want to reply?': 'Want to reply?',
        'What\'s on your mind?': 'What\'s on your mind?',
        'Votes': 'Votes',
        'kipaki portal': 'kipaki portal',
        'Select Fachstellen': 'Select Social Unit',
        'Go for voting': 'Go for voting',
        'Actions': 'Actions',
        'You have messages': 'You have {0} messages',
        'View all': 'View all',
        'Message': 'Message',
        'Notifications': 'Notifications',
        'Organization Details': 'Organization Details',
        'Showing out of records': 'Showing {0} out of {1} records',
        'Publication Description': 'Publication Description',
        'Are you sure want to reject this case?': 'Are you sure want to reject this case?',
        'Amount donated!': 'Amount donated!',
        'Case added for club voting successfully!': 'Case added for club voting successfully!',
        'Case rejected!': 'Case rejected!',
        'About case': 'About case',
        'Fachstellen name': 'Social Unit name',
        'Fachstellen type': 'Type of department',
        'Discussion': 'Discussion',
        'Add comment': 'Add comment',
        'Fachstellen details': 'Social Unit details',
        'Export': 'Export',
        'Settings': 'Settings',
        'Give Your Vote': 'Give Your Vote',
        'Kipaki charity dashboard | version 1.0': 'Kipaki charity dashboard | version 1.0',
        'Themes': 'Themes',
        'Login to your account': 'Login to your account',
        'Forgot password?': 'Forgot password?',
        'Back to login': 'Back to login',
        'Reset password': 'Reset password',
        'Club Name': 'Club Name',
        'Grid view': 'Grid view',
        'List view': 'List view',
        'Logout': 'Logout',
        'Organizations': 'Organizations',
        'Drag': 'Drag',
        'Added Patenkinder / fachstellen / clubs': 'Added GodChild / Social Unit / clubs',
        'Cases per Types': 'Cases per Types',
        'Over All Cases': 'Over All Cases',
        'confirmed amount': 'confirmed amount',
        'fachstellen / clubs per Organisation': 'Social Unit / clubs per Organisation',
        'Cases / amount per Fachstellen': 'Cases / amount per Social Unit',
        'Recent cases': 'Recent cases',
        'Dashboard': 'Dashboard',
        'Stage 1': 'Pending',
        'Stage 2': 'Sent for Voting',
        'Stage 3': 'Confirmation Pending',
        'Donated': 'Confirmed',
        'Rejected ': 'Rejected',
        'Fachstellen contact': 'Social Unit contact',
        'Email Templates': 'Email Templates',
        'Email Template': 'Email Template',
        'Manage Email Templates': 'Manage Email Templates',
        'Create Email Template': 'Create Email Template',
        'Mail Content': 'Mail Content',
        'Subject': 'Subject',
        'Edit Email Template': 'Edit Email Template',
        'Preview': 'Preview',
        'Are you sure want to skip voting for this case?': 'Are you sure want to skip voting for this case?',
        'There is no discussion started.': 'There is no discussion started.',
        'Remove': 'Remove',
        'Manage Groups': 'Manage Groups',
        'Created By': 'Created By',
        'Create Group': 'Create Group',
        'Update Group': 'Update Group',
        'Group': 'Group',
        'Manage Classes': 'Manage Classes',
        'Class': 'Class',
        'Fachstellen Person Name': 'Department\'s Person Name',
        'Why skip voting?': 'Begründung Überspringen der Abstimmung',
        'Skip vote description': 'Skip vote description',
        'Re-open': 'Re-open',
        'Are you sure want to re-open this case?': 'Are you sure want to re-open this case?',
        'Select Group': 'Select Group',
        'Select Class': 'Select Class',
        'Spenders': 'Spenders',
        'Once': 'Once',
        'Yearly': 'Yearly',
        'Donation Period': 'Donation Period',
        'Fachstellen wise patenkinder': 'Amount of Godchild per Social Unit',
        'Year wise patenkinder': 'Amount of Godchild each year',
        'Country wise patenkinder': 'Amount of Godchild per country',
        'Donation': 'Donation',
        'Payment Date': 'Payment Date',
        'Letter Sent': 'Letter Sent',
        'Letter Sent?': 'Letter Sent?',
        'Spender Donation': 'Spender Donation',
        'Create Donation': 'Create Donation',
        'Manage spender Donation': 'Manage spender Donation',
        'Donation Amount': 'Donation Amount',
        'Update Donation': 'Update Donation',
        'No.': 'No.',
        'Godchild': 'Godchild',
        'Fachstelle': 'Fachstelle',
        'Account No.': 'Account No.',
        'Manage Accounts': 'Manage Accounts',
        'Create Account': 'Create Account',
        'Update Account': 'Update Account',
        'Accounts': 'Accounts',
        'Account': 'Account',
        'Account Groups': 'Account Groups',
        'Account Classes': 'Account Classes',
        'Groups': 'Groups',
        'Classes': 'Classes',
        'Create Class': 'Create Class',
        'Update Class': 'Update Class',
        'Booking Date': 'Booking Date',
        'Currency code': 'Currency code',
        'Document date': 'Document date',
        'Please enter a number': 'Please enter a number',
        'Debited from': 'Debit',
        'Credited to': 'Credit',
        'Select currency code': 'Select currency code',
        'Booking Amount': 'Booking Amount',
        'Booking Text': 'Booking Text',
        'Update Account Booking': 'Update Account Booking',
        'Create Account Booking': 'Create Account Booking',
        'My Files': 'My Files',
        'Account no': 'Account no',
        'Account name': 'Account name',
        'Booking list': 'Booking list',
        'To': 'To',
        'Receipt No': 'Receipt No',
        'Credit': 'Credit',
        'Debit': 'Debit',
        'Total': 'Total',
        'Account Bookings': 'Account Bookings',
        'Group No.': 'Group No.',
        'Class No.': 'Class No.',
        'Of': 'Of',
        'Balance': 'Balance',
        'Previous year': 'Previous year',
        'To account': 'To account',
        'Booking Text': 'Booking Text',
        'Add to list': 'Add to list',
        'Currency rate': 'Currency rate',
        'Close': 'Close',
        'General Account Settings': 'General Account Settings',
        'Account Settings': 'Account Settings',
        'Area document no.': 'Area document no.',
        'Start date': 'Start date',
        'End date': 'End date',
        'Close booking year': 'Close booking year',
        'Reset booking year': 'Reset booking year',
        'Manage closed booking year': 'Manage closed booking year',
        'Zero balance accounts': 'Zero balance accounts',
        'Filter': 'Filter',
        'Class Type': 'Class Type',
        'Aktive': 'Aktive',
        'Passiv': 'Passiv',
        'Ertrag': 'Ertrag',
        'Aufwand': 'Aufwand',
        'Update list': 'Update list',
        'Company': 'Company',
        'Individual': 'Individual',
        'Type': 'Type',
        'Select type': 'Select type',
        'Confirmed amount and its description': 'Confirmed amount and its description',
        'Remarks': 'Remarks',
        'Click on member image to see his/her remarks': 'Click on member image to see his/her remarks',
        'Please first create a Fachstellen': 'Please first create a Social unit',
        'Approval Mail': 'Approval Mail',
        'Please first create a Patenkinder': 'Please first create a GodChild',
        'Access Users': 'Access Users',
        'Recent Activities': 'Recent Activities',
        '0 to 5 Age': '0 to 5 Age',
        '6 to 10 Age': '6 to 10 Age',
        '11 to 18 Age': '11 to 18 Age',
        'Above 18': 'Above 18',
        'Income statement from': 'Income statement from',
        'to': 'to',
        'Currency': 'Currency',
        'Expenditure': 'Expenditure',
        'Earnings': 'Earnings',
        'Income statement-total debit/credit': 'Income statement-total debit/credit',
        'Profit': 'Profit',
        'Balance per': 'Balance per',
        'Active': 'Active',
        'Passive': 'Passive',
        'Balance sheet total debit / credit': 'Balance sheet total debit / credit',
        'Yearly Report': 'Yearly Report',
        'Daily Report': 'Daily Report',
        'Past Cases': 'Past Cases',
        'Confirmed Cases': 'Confirmed Cases',
        'Tag': 'Tag',
        'Select Case': 'Select Case',
        'No activity found.': 'No activity found.',
        'Income Statement': 'Income Statement',
        'Add Remark': 'Add Remark',
        'Skip': 'Skip',
        'Note:': 'Note:',
        'Voters': 'Voters',
        'To Fachstellen': 'To Fachstellen',
        'Receipt number': 'Receipt number',
        'File manager': 'File manager',
        'Manage Folders': 'Manage Folders',
        'Create Folder': 'Create Folder',
        'Folder ID': 'Folder ID',
        'Select Contacts': 'Select Contacts',
        'Update folder': 'Update folder',
        'Folder': 'Folder',
        'Show Role': 'Show Role',
        'Click the "Cases" Tab to Manage Cases': 'Click the "Cases" Tab to Manage Cases',
        'Click "+" to add new Case': 'Click "+" to add new Case',
        'Choose a Godchild or press "Next" to Add God Child from the Godchild tab, if its not added': 'Choose a Godchild or press "Next" to Add God Child from the Godchild tab, if its not added',
        'Click the tab to Manage GodChild': 'Click the tab to Manage GodChild',
        'Click "+" to add new Godchild': 'Click "+" to add new Godchild',
        'Click icon to give your vote': 'Click icon to give your vote',
        'Click any icon to give your vote': 'Click any icon to give your vote',
        'Add remarks here if you want': 'Add remarks here if you want',
        'Press "Add Remarks" to Add Remarks, <br /> Press "Skip" if you don\'t want to add voting remarks': 'Press "Add Remarks" to Add Remarks <br /> Press "Skip" if you don\'t want to add voting remarks',
        'Click on your image to see your remarks, if you have added': 'Click on your image to see your remarks, if you have added',
        'Enter Comment and press "Add Comment" button': 'Enter Comment and press "Add Comment" button',
        'Comment added is shown here': 'Comment added is shown here',
        'Click "Reply" to reply over a comment': 'Click "Reply" to reply over a comment',
        'Enter reply message and press "Post" Button': 'Enter reply message and press "Post" Button',
        'Your reply will be shown here': 'Your reply will be shown here',
        'Click "Social Unit" to Manage Social Unit': 'Click "Social Unit" to Manage Social Unit',
        'By clicking on "+" user can add new "Social Unit", <br> where user has to fill form of the Social Unit': 'By clicking on "+" user can add new "Social Unit", <br> where user has to fill form of the Social Unit',
        'Fill Data to create Social Unit': 'Fill Data to create Social Unit',
        'Click "Godchild" to Manage Godchild': 'Click "Godchild" to Manage Godchild',
        'By clicking on "+" user can add new "Godchild", <br> where user has to fill form of the Godchild': 'By clicking on "+" user can add new "Godchild", <br> where user has to fill form of the Godchild',
        'Fill Data to create Godchild': 'Fill Data to create Godchild',
        'Click "cases" to Manage cases': 'Click "cases" to Manage cases',
        'By clicking on "+" user can add new "Case", <br> where user has to fill form of the Case': 'By clicking on "+" user can add new "Case", <br> where user has to fill form of the Case',
        'Fill Data to create Case': 'Fill Data to create Case',
        'Get Started': 'Get Started',
        'Income statement-sum debit / credit': 'Income statement-sum debit / credit',
        'Search & Reports': 'Search & Reports',
        'Report': 'Report',
        'Nick Name': 'Nick Name',
        'Are you sure want to delete this comment?': 'Are you sure want to delete this comment?',
        'Next': 'Next',
        'Open cases': 'Open cases',
        'Archive': 'Archive',
        'You are logged in with the auto generated credentials.': 'You are logged in with the auto generated credentials.',
        'Click Here': 'Click Here',
        'to Change password.': 'to Change password.',
        'No Notification found.': 'No Notification found.',
        'Open Cases': 'Open Cases',
        'Privacy Policy': 'Privacy Policy',
        'Social Unit Registration is confirmed !': 'Social Unit Registration is confirmed !',
        'Header': 'Header',
        'Footer': 'Footer',
        'Left': 'Left',
        'Are you sure want to reset freezed booking list?': 'Are you sure want to reset freezed booking list?',
        'Are you sure want to freezed booking list?': 'Are you sure want to freezed booking list?',
        'needy': 'Needy',
        'special': 'Special',
        'Reject case description': 'Reject case description',
        'Case re-open successfully!': 'Case re-open successfully!',
        'stage_1': 'Pending',
        'stage_2': 'Sent for Voting',
        'stage_3': 'Confirmation Pending',
        'donated': 'Confirmed',
        'rejected': 'Rejected',
        'Manage Admins': 'Manage Admins',
        'Admins': 'Admins',
        'Create Admins': 'Create Admins',
        'The password field must be at least 8 characters.': 'The password field must be at least 8 characters.',
        'Erstaufnahme': 'New Patenkind',
        'Confirmed Amount': 'Confirmed Amount',
        'payment_date': 'Payment Dates',
        'payment_status': 'Payment Status',
        'paid': 'Paid',
        'unpaid': 'Unpaid',
        'paidon': 'Paid ON',
        'Paid Date Case': 'Payment Date Successfully Added',
        'pdf download': 'PDF Download',
        'export excel' : 'Export Excel',
        'Past Cases': 'Past Cases',
        'Office comments' : 'Bemerkungen der KiPaKi Geschäftsstelle',
        'select file' : 'select file',
        'view file' : 'view file',
        'delete file' : 'delete file',
        'Fields with one! Can be viewed by the board. Please anonymize text.':'Fields with one! Can be viewed by the board. Please anonymize text.',
        'What (e.g. membership fee FC Musterdorf)' : 'What (e.g. membership fee FC Musterdorf)',
        'Justification and any excess':'Justification and any excess',
        'saldo': 'Balance',
        'Chat with Social unit' : 'Chat with Social unit',
        'Chat with Orgaisation Admin' : 'Chat with Orgaisation Admin',
    }
}


// WEBPACK FOOTER //
// ./src/assets/lan/en.js